import { Spinner } from "react-bootstrap";

const FormButtons = ({
  loadingButton,
  status,
  onWhiteClick,
  onBlackClick,
  isSubmitting,
  detailId
}) => {
  const isCreateMode = !detailId;
  const isDraft = status === "draft";
  const isPublished = status === "published";

  // White button label
  const whiteLabel = isCreateMode
    ? "Save Draft"            // create mode
    : isDraft
      ? "Update"              // editing draft
      : "Unpublish";          // editing published

  // Black button label
  const blackLabel = isCreateMode
    ? "Publish"               // create mode
    : isDraft
      ? "Publish"             // editing draft
      : "Update";             // editing published

  return (
   <>
      {/* WHITE BUTTON */}
      <button
        type="button"
        className="btn-white"
        onClick={onWhiteClick}
        disabled={loadingButton === "white" && isSubmitting}
      >
        {loadingButton === "white" && isSubmitting ? (
          <Spinner size="sm" />
        ) : (
          whiteLabel
        )}
      </button>

      <button
        type="button"
        className="btn-black"
        onClick={onBlackClick}
        disabled={loadingButton === "black" && isSubmitting}
      >
        {loadingButton === "black" && isSubmitting ? (
          <Spinner size="sm" />
        ) : (
          blackLabel
        )}
      </button>
    </>

  );
};

export default FormButtons;
